export const SHIFT_SELECTION_STATUS = {
    CONFLICT: 'CONFLICT',
    SELECTED: 'SELECTED',
    UNSELECTED: 'UNSELECTED'
}

export const REPEAT_FREQUENCY = {
    WEEKDAYS: 'Weekdays',
    WEEKLY: 'Weekly',
    DAILY: 'Daily'
}